/** Minimum time the Placy landing splash stays visible on each app open. */
export const SESSION_SPLASH_MIN_MS = 2000;

/** Cross-fade duration from landing splash into home / login. */
export const SESSION_SPLASH_EXIT_MS = 520;

/** Do not block the app forever if session refresh hangs (e.g. slow mobile networks). */
export const SESSION_SPLASH_AUTH_WAIT_MAX_MS = 8000;

/**
 * PayPlus browser return is a full document load — skip the 2s Placy landing splash
 * so payment success/cancel UX is immediate.
 */
export function shouldSkipSessionSplashForLocation(pathname: string): boolean {
  const base = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '');
  let rel = pathname || '/';
  if (base && (rel === base || rel.startsWith(`${base}/`))) {
    rel = rel === base || rel === `${base}/` ? '/' : rel.slice(base.length) || '/';
  }
  const normalized = rel.length > 1 && rel.endsWith('/') ? rel.slice(0, -1) : rel || '/';
  return (
    normalized === '/payment/success' ||
    normalized === '/payment/failure' ||
    normalized === '/payment/cancel'
  );
}
